import createStore from '@Stores/base-factories';
import hookSiteSelectedFactory from '@Stores/base-factories/store-site-selection';

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('dba')
  .extendHookCollectionsFactory('dbas')
  .factory()

export {
  Provider as ConsentDBAsProvider,
  useStore as useConsentDBAsStore,
}
